<template>
    <LayoutColumn>
        <SectionTitle>
            {{ $t('Search.labels.databaseTitle') }}
        </SectionTitle>
        <SectionBlock class="row-space">
            <LayoutContainer>
                <LayoutColumn>
                    <SequenceTypeField class="mb0" />
                </LayoutColumn>
                <LayoutColumn>
                    <DBTypeField
                        class="mb0"
                        :multiple="multiple"
                    />
                </LayoutColumn>
            </LayoutContainer>
            <div
                v-if="isSlowSearch"
                class="slow-warning"
            >
                <PtIcon icon="SolidWarning" />
                <span>{{ $t('Search.propver.Preferences.slowWarning') }}</span>
            </div>
        </SectionBlock>
    </LayoutColumn>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import * as Widgets from '../widgets/index';
import * as Components from '../components/index';
import { ABST_NUC, ABST_PROTEIN } from '../constants';

export default {
    components: {
        ...Components,
        ...Widgets,
        PtIcon,
    },
    inject: ['store'],
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isSlowSearch() {
            const isProteinSequenceType = this.store.settingValues.sequenceType === ABST_PROTEIN;
            const hasNucleotideDbType = (this.store.settingValues.dbType || []).includes(ABST_NUC);
            return isProteinSequenceType && hasNucleotideDbType;
        },
    },
};
</script>
